import jwt from 'jwt-decode';

const CLOCK_TOLERANCE = 5;

export const reauthDelay = (CLOCK_TOLERANCE * 1000) / 2;

// TODO test this service :(
export const isNearlyExpired = (accessToken: string): boolean => {
  // exp is in seconds, not miliseconds
  const payload: { exp: number } = jwt(accessToken);
  const clockTimestamp = Math.floor(Date.now() / 1000);

  return payload && payload.exp < clockTimestamp - CLOCK_TOLERANCE;
};
